import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {ApiConnectService} from './api-connect.service';
import {HttpClient, HttpHeaders, HttpParams, HttpXsrfTokenExtractor} from '@angular/common/http';
import {NotificationsService} from './notifications.service';
import {UserService} from "./user.service";

@Injectable()
export class AuthService {

  constructor(private http: HttpClient,
              private router: Router,
              private tokenExtractor: HttpXsrfTokenExtractor,
              private cookieService: CookieService,
              private notificationsService: NotificationsService,
              private apiURL: ApiConnectService,
              private userService: UserService) {
  }

  isAuthenticated() {
    if (localStorage.getItem('Authenticated') === null) {
      localStorage.setItem('Authenticated', 'false');
      return false;
    } else if (localStorage.getItem('Authenticated') === 'false') {
      return false;
    } else if (localStorage.getItem('Authenticated') === 'true') {
      return true;
    }

  }

  signIn(login, password) {
    const authorization: string = 'Basic ' + btoa(login + ':' + password);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': authorization,
      'offset': this.userService.getTimezoneOffset()
    });

    return this.http.get(this.apiURL.logIn, {headers: headers, observe: 'response', withCredentials: true});
  }

  changePass(login, oldPassword, newPassword) {
    return this.http.post(this.apiURL.changePass + '?' + new HttpParams().set("login", login).set("oldPassword",  oldPassword).set("newPassword",  newPassword), { observe: 'response' });
  }

  signOut() {
    const headers = new HttpHeaders({
      'X-XSRF-TOKEN': this.tokenExtractor.getToken() as string
    });

    this.http.post(this.apiURL.logOut, null)
      .subscribe((res) => {
          let lang = localStorage.getItem('lang');
          localStorage.clear();
          localStorage.setItem('lang', lang);
          this.cookieService.deleteAll();
        },

        () => {
        }
      );

    this.notificationsService.clearNearNotification();
    this.router.navigate(['/signin']);
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/auth.service.ts